import { ControlType } from "./property-controls";
export function propertyValues(propertyControls, initialValues = {}, baseInitialValues) {
    const values = {};
    const controlKeys = Object.keys(propertyControls);
    for (const name of controlKeys) {
        const control = propertyControls[name];
        if (!control)
            continue;
        const value = propertyValue(control, initialValues[name], initialValues, baseInitialValues ?? initialValues);
        if (value !== undefined)
            values[name] = value;
    }
    return values;
}
export function propertyValue(control, initialValue, initialValues = {}, baseInitialValues = initialValues) {
    switch (control.type) {
        case ControlType.Hidden:
            return initialValue ?? control.defaultValue;
        case ControlType.Date:
            return getControlValue(new Date(initialValue).toJSON() !== null, control, initialValue, initialValues, baseInitialValues);
        case ControlType.Color: // TODO
        case ControlType.File:
        case ControlType.Image:
        case ControlType.String:
            return getControlValue(typeof initialValue === "string", control, initialValue, initialValues, baseInitialValues);
        case ControlType.Number:
            return getControlValue(typeof initialValue === "number", control, initialValue, initialValues, baseInitialValues);
        case ControlType.Boolean:
            return getControlValue(typeof initialValue === "boolean", control, initialValue, initialValues, baseInitialValues);
        case ControlType.Enum:
            const enumControl = control;
            return getControlValue(enumControl.options.includes(initialValue), enumControl, initialValue, initialValues, baseInitialValues);
        case ControlType.Array:
            const arrayControl = control;
            const arrayValue = getControlValue(Array.isArray(initialValue) && initialValue?.length > 0, arrayControl, initialValue?.length > 0 ? initialValue : undefined, initialValues, baseInitialValues);
            return arrayValue
                ?.slice(0, arrayControl.maxCount)
                .map(v => propertyValue(arrayControl.propertyControl, v, undefined, baseInitialValues));
        case ControlType.Object:
            const objectControl = control;
            const objectValue = getControlValue(typeof initialValues === "object", objectControl, initialValue, initialValues, baseInitialValues);
            return propertyValues(objectControl.propertyControls, objectValue, baseInitialValues);
    }
}
function getControlValue(useInitial, control, initialValue, initialValues = {}, baseInitialValues = initialValues) {
    if (initialValue && useInitial)
        return initialValue;
    // Attempt to coerce value from initial values (if initial value is falsey or incorrect type)
    const coercedInitalValue = control.coerce?.(initialValue, initialValues, baseInitialValues);
    if (coercedInitalValue != null)
        return coercedInitalValue;
    // Fallback to default value (only if both initial and coerced value is nullish)
    return initialValue ?? control.defaultValue;
}
//# sourceMappingURL=propertyValues.js.map